import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { PatientAccModel } from '../models/PatientAccModel';
import { URLsConfig } from '../URLsConfig';


@Injectable()
export class PatientAccService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public GetPatientInvoice(w_type: string, fromdate: string,todate: string, w_patient: string , compCode: string)
    {
      let params = new HttpParams();
        params = params.append("w_type", w_type);
        params = params.append("fromdate", fromdate);
        params = params.append("todate", todate);

        params = params.append("w_patient", w_patient);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };

      return this.http.get<PatientAccModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/PatientAcc/GetPatientInvoices',options);
    }

  }
